import { render } from "./practice-notes.html?vue&type=template&id=444c386c&scoped=true&ts=true&external"
import script from "./practice-notes.ts?vue&type=script&lang=ts&external"
export * from "./practice-notes.ts?vue&type=script&lang=ts&external"

import "./practice-notes.scss?vue&type=style&index=0&id=444c386c&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-444c386c"]])

export default __exports__